<template>
  <div class="wecom-kf-rule" v-loading="loading">
    <el-form label-width="140px" size="small" style="max-width: 760px">
      <el-form-item label="业务规则">
        <el-input v-model="form.ruleText" type="textarea" :rows="12" placeholder="退款、改签、投诉口径，以及禁止推诿和敷衍" />
      </el-form-item>
      <el-form-item label="首响超时（秒）">
        <el-input-number v-model="form.firstResponseTimeoutSeconds" :min="1" :max="86400" />
      </el-form-item>
      <el-form-item label="间隔超时（秒）">
        <el-input-number v-model="form.gapTimeoutSeconds" :min="1" :max="86400" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </el-form-item>
      <el-form-item>
        <span class="mask">模型地址、模型名和密钥在系统设置里配置。</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getWecomKfRule, saveWecomKfRule } from "@/api/wecom_kf";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        ruleText: "",
        firstResponseTimeoutSeconds: 60,
        gapTimeoutSeconds: 180
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      getWecomKfRule().then((res) => {
        const data = res.data || {};
        this.form = {
          ruleText: data.ruleText || "",
          firstResponseTimeoutSeconds: data.firstResponseTimeoutSeconds || 60,
          gapTimeoutSeconds: data.gapTimeoutSeconds || 180
        };
      }).finally(() => {
        this.loading = false;
      });
    },
    save() {
      this.saving = true;
      saveWecomKfRule({
        ruleText: this.form.ruleText,
        firstResponseTimeoutSeconds: this.form.firstResponseTimeoutSeconds,
        gapTimeoutSeconds: this.form.gapTimeoutSeconds
      }).then(() => {
        this.$message.success("已保存");
      }).finally(() => {
        this.saving = false;
      });
    }
  }
};
</script>

<style scoped>
.mask {
  color: #909399;
  font-size: 12px;
}
</style>
